<template>
  <BLayoutExpansionTableAsync
    :value="curators"
    v-bind="$attrs"
    :actions="actions"
    :loading="isLoading"
    :readonly="readonly"
    title="Кураторы"
    type-autocomplete="participants"
    type-table="participants"
    name="participants"
    return-object
    @action:append="onAppendParticipant"
    @action:delete="onRemoveParticipant"
    @action:edit="onEditParticipant"
  />
</template>

<script>
import BLayoutExpansionTableAsync from '@/components/layouts/BLayoutExpansionTableAsync.vue'
import { DELETE, EDIT } from '@/helpers/enums/table-actions'
import { lkParticipantPermissions as Permissions } from '@/helpers/enums/permission-models'
import { createPublicationsCuratorModalModal } from '@/views/Publications/utils'
import { PublicationsApi } from '@/api/resources'


export const TABLE_ACTIONS = Object.freeze([
  EDIT,
  DELETE,
])

export default {
  name: 'PublicationsParticipantsExpansionTable',
  components: { BLayoutExpansionTableAsync },
  props: {
    publication: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    curators: [],
  }),
  computed: {
    actions() {
      const actions = TABLE_ACTIONS
      const restrictedActions = []
      if (this.$access(Permissions.edit)) restrictedActions.push(EDIT)
      if (this.$access(Permissions.delete)) restrictedActions.push(DELETE)
      return actions.filter((x) => restrictedActions.includes(x))
    },
    readonly() {
      return !this.$access(Permissions.edit)
    },
  },
  watch: {
    publication: {
      immediate: true,
      handler(v) {
        if (v) {
          this.curators = v.curators
        }
      },
    },
  },
  created() {
    this.api = new PublicationsApi()
  },
  methods: {
    async onAppendParticipant(participant) {
      this.isLoading = true
      try {
        await this.api.addCuratorParticipants(this.publication.id, { curators_id: participant.id })
        this.curators.push(participant)
      } catch (e) {
        this.$notice.errors(e)
      }
      this.isLoading = false
    },
    async onRemoveParticipant(participant, callback) {
      const unwatch = callback?.()

      this.isLoading = true
      try {
        await this.api.removeCuratorParticipants(this.publication.id, { curators_id: participant.id })
        const idx = this.curators.findIndex((el) => el.id === participant.id)
        if (idx >= 0) {
          this.curators.splice(idx, 1)
        }
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
        unwatch?.()
      }
    },
    async onEditParticipant(participant) {
      const propsData = {
        participant_id: participant.id,
        on: {
          update: this.onUpdateUsersCount,
        },
      }
      const modal = await createPublicationsCuratorModalModal(this, propsData)
      await modal.open()
    },
    onUpdateUsersCount(participant_id, count) {
      const participant = this.curators.find((el) => el.id === participant_id)
      if (participant) {
        participant.users_count = count
      }
    },
  },
}
</script>
